var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8874 37.5639L10.9313 39.9166C10.2162 40.256 9.40889 39.6695 9.51075 38.8845L11.0975 26.6558C11.1362 26.3579 11.0389 26.0584 10.8325 25.8401L2.3609 16.8795C1.81709 16.3043 2.12544 15.3553 2.90349 15.2096L15.024 12.9398C15.3193 12.8846 15.5741 12.6995 15.7179 12.4357L21.622 1.60979C22.001 0.914845 22.9989 0.914845 23.3779 1.60979L29.282 12.4357C29.4259 12.6995 29.6806 12.8846 29.9759 12.9398L42.101 15.2105C42.8781 15.356 43.187 16.3032 42.6451 16.8788L34.9999 25",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6154 54.037H38.9969C40.5915 54.037 42.1717 53.736 43.6546 53.1498V53.1498C46.8872 51.8719 50.5029 51.9783 53.6548 53.4442L53.7551 53.4908C54.6687 53.9158 55.5622 52.8685 54.9987 52.0332L54.351 51.0729C52.9022 48.9252 52.1282 46.3937 52.1282 43.803V41.5185V41.5185C52.1282 34.6047 46.5235 29 39.6097 29H32C24.8203 29 19 34.8203 19 42V43.9259",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 37.5H44M27.5 42H44M37 46.5H31",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8889 46C27.4731 46 32 50.5269 32 56.1111C32 61.6953 27.4731 66.2222 21.8889 66.2222H18.4872H15.685C14.3851 66.2222 13.0967 65.9791 11.8862 65.5053C9.24752 64.4725 6.26454 64.5759 3.69066 65.7611C2.94094 66.1063 2.18779 65.2567 2.65253 64.5746L2.88207 64.2377C4.2453 62.2368 4.9744 59.8718 4.9744 57.4506V56.1111C4.9744 50.5269 9.5013 46 15.0855 46H21.8889ZM12 53.25C11.5858 53.25 11.25 53.5858 11.25 54C11.25 54.4142 11.5858 54.75 12 54.75H25C25.4143 54.75 25.75 54.4142 25.75 54C25.75 53.5858 25.4143 53.25 25 53.25H12ZM12 57.25C11.5858 57.25 11.25 57.5858 11.25 58C11.25 58.4142 11.5858 58.75 12 58.75H19.5C19.9143 58.75 20.25 58.4142 20.25 58C20.25 57.5858 19.9143 57.25 19.5 57.25H12Z",
    fill: "#ECBE08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.a747f9f87e26c3ecab467b46f5013b92.svg";
export { ForwardRef as ReactComponent };